<template>
    <div class="processListView-list">
        <el-container>
            <el-header style="height: auto; padding-top: 8px;">
                    <div style="margin-top:15px;float: left;">
                        <el-form :inline="true" class="demo-form-inline">
                          <el-row>
                            <el-form-item v-if="!isFromBusTab" label="应用名称">
                                <el-select style="width: 160px;" filterable clearable v-model="selectedAppId" @change="changeSelectedAppId" @clear="clearSelectedAppId"  placeholder="请选择">
                                    <el-option
                                        v-for="item in appsList"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="流程模板">
                                <el-select style="width: 120px;" filterable clearable v-model="searchParams.processServiceId" @change="processServiceChange"  placeholder="请选择模板">
                                    <el-option
                                        v-for="item in currentTemplateList"
                                        :key="item.processServiceId"
                                        :label="item.templateName"
                                        :value="item.processServiceId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="任务状态">
                                <el-select style="width: 100px;" @change="handleSearch" v-model="searchParams.state" clearable placeholder="请选择">
                                    <el-option
                                        v-for="item in taskState"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="子流程名称">
                                <el-select
                                    style="width: 120px;"
                                    v-model="searchParams.processInstanceId"
                                    filterable
                                    remote
                                    clearable
                                    reserve-keyword
                                    placeholder="请选择流程名称"
                                    :remote-method="queryProcessList"
                                    :loading="processNameLoading" 
                                    @change="selectProcessNameTrigger">
                                    <el-option
                                        v-for="item in processList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="role !== 'startedBy'" label="子流程发起人">
                                <el-input title='流程发起人' readonly style="width: 90px;" v-model="selectedStartedUser.selectedUserNames" @focus="chooseProcessStartedUser" ></el-input>
                                <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowStartedUserOrg'  :selectedUser="selectedStartedUser" ref="startedUserOrgPop" @nodeClick="processStartedUserSelectTrigger" />
                            </el-form-item>
                            <el-form-item  v-if="role !== 'assignee'"  label="子流程负责人">
                                <el-input :title='selectedProcessUser.selectedUserNames' readonly style="width: 90px;" v-model="selectedProcessUser.selectedUserNames" @focus="chooseProcessAssigneeUser" ></el-input>
                                <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowProcessUserOrg' :multiple='true' :selectedUser="selectedProcessUser" ref="processUserOrgPop" @nodeClick="processAssigneeSelectTrigger" />
                            </el-form-item>
                            <!-- <el-form-item label="子流程">
                                <el-select style="width: 110px;" @change="handleSearch" v-model="searchParams.hasSubProcess" placeholder="请选择">
                                    <el-option
                                        v-for="item in processInstanceTypeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item> -->
                            <!-- <el-form-item label="状态">
                                <el-select style="width: 90px;" @change="handleSearch" v-model="searchParams.state" placeholder="请选择">
                                    <el-option
                                        v-for="item in processStateList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item> -->
                            <el-form-item v-if="isFromBusTab" label="流程角色">
                                <el-select style="width: 90px;" @change="handleSearch" v-model="searchParams.processStartedBy"  placeholder="请选择">
                                    <el-option
                                        v-for="item in processStartedByList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-button type="primary" icon="el-icon-search" circle @click="handleSearch"></el-button>
                            <el-button icon="el-icon-s-operation" type="primary" circle title="状态模式"  @click="changeListMode"></el-button>
                        </el-row>
                    </el-form>
                </div>
            </el-header>
            <el-main class="table-main">
                <el-table
                    :height="tableHeight"
                    :style="tableStyle"
                    :data="instancesListTemp"
                    row-key="id"
                    :tree-props="{children: 'children'}"
                    :border="true"
                    v-loading="loading">
                <!-- <el-table-column type="index" label="序号" width="50"></el-table-column> -->
                <el-table-column prop="name" label="名称" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <a href="javascript:void(0)" v-if="'0'===scope.row.nodeType" style="color: #409eff;" @click="handleViewProcessDetail(scope.row)">{{scope.row.name}}</a>
                      <a href="javascript:void(0)" v-else style="color: #67c23a;" @click="handleTaskDetail(scope.row.id)">{{scope.row.name}}</a>
                    </template>
                </el-table-column>
                <el-table-column label="类别" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="'0'===scope.row.nodeType">流程</el-tag>
                        <el-tag v-else type="success">任务</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="templateName" label="流程模板" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="所属流程" width="130" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-tag v-if="'0'===scope.row.nodeType">{{scope.row.name}}</el-tag>
                        <el-tag v-else>{{scope.row.belongProcessInstanceName}}</el-tag>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    label="当前任务"
                    :show-overflow-tooltip="true"
                    >
                    <template slot-scope="scope" >
                        <CurrentTasksColumn
                            v-if="!scope.row.finish" 
                            :isFromBusTab="isFromBusTab"
                            :isShowOverflowTooltip="true"
                            :cellValue="scope.row['templateName']"
                            :taskInstanceList="scope.row['currentTasks']"
                            :processInstanceId="scope.row['id']"
                            :processInstanceName="scope.row['name']"
                            :createdByName="scope.row['assigneeUserName']"
                            :createdDate="scope.row['started']"
                            @navToMyTaskMyAssignee="navToMyTaskMyAssignee"
                            @navToBusiniessTaskTab="navToBusiniessTaskTab"
                        />
                        <el-tag v-if="scope.row.finish" type="primary" size="small">流程已完成</el-tag>
                    </template>
                </el-table-column> -->
                <el-table-column prop="finish" label="流程状态" width="80">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.finish" type="success" size="small">已完成</el-tag>
                        <el-tag v-else type="primary" size="small">进行中</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="startedBy.trueName" :show-overflow-tooltip="true"  label="流程发起人" width="85"></el-table-column>
                <el-table-column prop="assigneeUserName" :show-overflow-tooltip="true"  label="流程负责人" width="85"></el-table-column>
                <el-table-column prop="taskAssigneeUserName" :show-overflow-tooltip="true"  label="任务负责人" width="85"></el-table-column>
                <el-table-column width="80" prop="taskStatus" label="任务状态" >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.taskState === 3" type="unassigned" size="mini">未分配</el-tag>
                        <el-tag v-if="scope.row.taskState === 4" type="unclaimed" size="mini">待认领</el-tag>
                        <el-tag v-if="scope.row.taskState === 1" type="primary" size="mini">进行中</el-tag>
                        <el-tag v-if="scope.row.taskState === 6" type="warning" size="mini">快到期</el-tag>
                        <el-tag v-if="scope.row.taskState === 2" type="success" size="mini">已完成</el-tag>
                        <el-tag v-if="scope.row.taskState === 5" type="danger" size="mini">已延期</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="started" label="流程发起时间" :sortable="true" width="140"></el-table-column>
                <el-table-column  :show-overflow-tooltip="true" label="流程耗时" :sortable="true" width="95">
                    <template slot-scope="scope">
                     {{scope.row.processInstanceDurationTime}}
                    </template>
                 </el-table-column>
                <el-table-column label="流程角色" width="100">
                  <template slot-scope="scope">
                    <div>
                        <el-tag v-if="scope.row.startedBy && currentUserId===scope.row.startedBy.id" type="warning">我发起的</el-tag>
                        <el-tag v-else type="info">我参与的</el-tag>
                    </div>
                  </template>
                </el-table-column>
                <!-- <el-table-column   label="操作" width="225">
                    <template slot-scope="scope">
                        <el-button size="mini" title='流程图' circle icon="el-icon-picture-outline" @click="handelShowDiagram(scope.row)"></el-button>
                        <el-button v-if="scope.row.hasSubProcess==='1' && (scope.row.mainQry || !searchParams.complateTreeMode)" size="mini" icon="el-icon-s-grid" title="主子流程关系图" circle @click="handelShowProcessRelate(scope.row)"></el-button>
                        <el-button size="mini" v-if="scope.row.hasReports && (scope.row.mainQry || !searchParams.complateTreeMode)" title='业务树关系图' circle icon="el-icon-connection" @click="handelShowReportRelateTree(scope.row)"></el-button>
                        <el-button size="mini" v-if="scope.row.hasReports && scope.row.reportsCnt===1 && (scope.row.mainQry || !searchParams.complateTreeMode)" title="百川金字塔" class="iconfont icon-other-liucheng"  circle @click="handleShowOrgTreeView(scope.row)"></el-button>
                        <el-button size="mini" type="danger" v-if="scope.row.canCancelProcess && (currentUserId===scope.row.startedBy.id || currentUserId===scope.row.assigneeUserId)" title='删除' circle icon="el-icon-delete" @click="handleCancelProcessInstances(scope.row)"></el-button>
                        <el-tooltip content="保存为常用负责人配置后，用该流程的流程模板发起流程时可以选择使用配置来快速发起流程" placement="top">
                            <el-button type="primary" v-if="scope.row.finish && currentUserId===scope.row.startedBy.id && !scope.row.commonUse" title='保存为常用配置' size="mini" icon="el-icon-s-claim" circle @click="saveProcessCommonUseConfig(scope.row)"></el-button>
                        </el-tooltip>
                        <el-button type="primary" v-if="scope.row.finish && currentUserId===scope.row.startedBy.id && scope.row.commonUse" title='取消常用配置' size="mini" icon="el-icon-s-release" class="cancelBtn" circle @click="cancelProcessCommonUseConfigBOByProcesssId(scope.row)"></el-button>
                    </template>
                </el-table-column> -->
            </el-table>
                <el-row type="flex" justify="end" v-if="tableStyle!=''">
                  <el-pagination
                      background
                      layout="sizes,total, prev, pager, next"
                      :total="page.totalPageNum"
                      :current-page="page.currentPage"
                      @size-change="handleSizeChange"
                      :page-size="page.pageSize"
                      @current-change="queryTableData"
                      :page-sizes="[10, 30, 50, 100]"
                  />
               </el-row>
            </el-main>
        </el-container>
        <el-dialog
            title="流程详情"
            :fullscreen=true
            :visible.sync="isShowProcessDetail"
            append-to-body
            >
            <ProcessDetail :key="loadTimer" :isFinish="isFinish" :instances="instancesInfo" :isCancel="isCancel" @reloadProcess="reloadProcess"/>
        </el-dialog>
        <el-drawer
            title="流程详情"
            :visible.sync="isShowProcessDetailDrawer"
            :direction="direction"
            size="90%"
            >
            <div style="margin-top: -20px;">
              <ProcessDetail :key="loadTimer" :isFinish="isFinish" :instances="instancesInfo" :isCancel="isCancel" :isShowNewMode="true" @reloadProcess="reloadProcess" :isFromBusTab="isFromBusTab" @navToBusiniessTaskTab="navToBusiniessTaskTab"/>
            </div>
        </el-drawer>
        <!-- 显示图标 -->
        <el-dialog
            title="流程图"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowDiagram"
            custom-class="diagram-dialog">
            <ProcessDiagram
              ref="processDiagrams"
              :key="loadTimer"
              :processInstance="instancesInfo"
              :taskList="taskList"
              :archiveTemplateTreeList="archiveTemplateTreeList"
              @refreshProcessList="handelProcessDetail"
            />
        </el-dialog>
        <el-dialog
            title="流程任务干预"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowSetting"
            @close="closeProcessSetting"
            >
            <ProcessSetting
              :processInstance="instancesInfo"
              :taskList="taskList"
              :archiveTemplateTreeList="archiveTemplateTreeList"
              @refreshProcessList="handelProcessDetail"
            />
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelProcessSetting">取 消</el-button>
                <!-- <el-button type="primary" @click="saveProcessSetting">保存配置</el-button> -->
            </span>
        </el-dialog>
         <el-dialog
            title="主子流程关系图"
            :fullscreen=true
            :visible.sync="isShowProcessRelate"
            append-to-body
            >
            <ProcessRelateTree :key="loadTimer" ref="processRelateTree" :processInstanceId ="currentProcessInstanceId" />
        </el-dialog>
        <el-dialog
            title="业务树关系图"
            custom-class="process-report-dialog"
            class="business-report-tree"
            :fullscreen=true
            :visible.sync="isShowReportRelateTree"
            append-to-body
            >
            <ProcessReportList :key="loadTimer" ref="reportRelateTree" :reports ="processReportList" />
        </el-dialog>
        <el-dialog
            title="流程动态信息列表"
            width="90%"
            :fullscreen=true
            :visible.sync="isShowPreview"
            >
            <ProcessAdjList ref="processAdjList" :processInstanceId="currentProcessInstanceId" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowPreview=false">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="选择所属流程"
            :visible.sync="isShowProcessListDialog"
            append-to-body
            width = "60%">
            <ProcessPop  :field="{}" ref="processSelect" :formData="{}" @nodeClick="selectTrigger"/>
            <span slot="footer" class="dialog-footer">
                <el-button  type="primary" @click="handleClickOk">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title=""
            :visible.sync="isShowOrgTreeDialog"
            :fullscreen = true
            append-to-body
            >
            <VueOrgTree ref="reportOrgTree" :key="vueOrgTreeLoadTimer" :treeData="treeOrgData"/>
        </el-dialog>
        <el-dialog
            title="任务详情"
            custom-class="needWorkingPop"
            :fullscreen=true
            :visible.sync="isShowTaskDetail"
            append-to-body
            >
             <div style="height: 100%;">
              <TaskDetail
                  class="neewWorkingTask"
                  v-if="isShowTaskDetail"
                  :taskInfo="taskInfo"
                  :tabId="tabId"
                  :key="loadTimer"
                  :isNewPage="true"
                  @taskClaim="handleTaskClaim"
                  @taskComplete="handleTaskComplete"
                  @taskDelete="handleTaskDelete"
                  @taskHidden="handleTaskHidden"
                  @taskTemporarySave="handleTaskTemporarySave"
                  @taskRevoke="handleTaskRevoke"
                  @transferTask="transferTask"
                  @setShowleftList="setShowleftList"
              />
             </div>
        </el-dialog>
    </div>
</template>

<script>
    // eslint-disable-next-line standard/object-curly-even-spacing
    import { clone, isEmpty} from 'lodash';
    // eslint-disable-next-line standard/object-curly-even-spacing
    import {getProcessTaskDetail, processTaskClaim, processTaskComplete, processTaskRevoke, processTaskDelete, processTaskHidden, processTaskTemporarySave,
        transferAssignee, getSerialNumber, getProcessInstancesList, getPublishedApplicationList, saveProcessTreeListQry, getMenuProcessTreeList,
        cancelProcessCommonUseConfigBOByProcesssId, saveProcessCommonUseConfig, getProcessInstancesDetail, cancelProcessInstance, deleteProcessInstance, getAllUserTask,
        getArchiveTemplateTreeList, getProcessTemplateList, getModelFormReportOrgTree, getModelFormReportTree} from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    // import ProcessDetail from '@/pages/process/MyProcess/ProcessDetail';
    // import ProcessDiagram from '@/pages/process/MyProcess/ProcessDiagram';
    import ProcessRelateTree from '@/components/ProcessRelateTree';
    import ProcessAdjList from '@/components/ProcessAdjList';
    import ProcessReportList from '@/pages/process/MyProcess/ProcessReportList';
    import CurrentTasksColumn from '@/pages/process/MyProcess/CurrentTasksColumn';

    import VueOrgTree from '@/components/VueOrgTree';

    export default {
        mixins: [ mixinsNav ],
        components: {
            // ProcessDetail,
            // ProcessDiagram,
            ProcessRelateTree,
            ProcessAdjList,
            ProcessReportList,
            VueOrgTree,
            CurrentTasksColumn
        },
        data () {
            return {
                taskInfo: {},
                isShowTaskDetail: false,
                selectedAppId: '',
                selectedApp: {},
                currentTemplateList: [],
                appsList: [],
                selectedProcessServiceIdArray: '',
                vueOrgTreeLoadTimer: '',
                treeOrgData: {},
                isShowOrgTreeDialog: false,
                isShowProcessListDialog: false,
                processStartedBy: '', // 默认全部 1我发起2我参与
                processStartedByList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: '1',
                        label: '我发起'
                    }, {
                        value: '2',
                        label: '我参与'
                    }],
                currentCnt: 0,
                instancesListTempCnt: 0,
                instancesListTemp: [], // 临时列表
                instancesList: [], // 列表数据
                loading: false, // 列表的loading状态
                searchKeyWord: '', // 查询的关键字,
                processInstanceId: '', // 流程实例ID
                instancesInfo: {},
                isFinish: false,
                isCancel: false,
                isShowProcessDetail: false,
                isShowProcessDetailDrawer: false,
                direction: 'rtl',
                isShowDiagram: false,
                taskList: [],
                archiveTemplateTreeList: [],
                isShowSetting: false,
                isReloadProcess: false,
                loadTimer: '',
                currentUserId: '',
                currentUserName: '',
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                currentProcessInstanceId: '',
                isShowProcessRelate: false,
                isShowReportRelateTree: false,
                processReportList: [], // 当前流程绑定的报表
                searchParams: {
                    complateTreeMode: false,
                    pageSize: 100000,
                    currentPage: 1,
                    processServiceId: '', // 流程模板对应的方案ID
                    startedByUserId: '', // 流程发起人ID
                    assigneeUserId: '', // 流程负责人Id
                    hasSubProcess: '', // 默认全部
                    isTree: true, // 树列表结构
                    allProcessInstance: true, // 查询所有流程实例
                    processStartedBy: '', // 默认全部1我发起2我参与
                    serviceName: '',
                    state: 1 // 任务状态 ：默认进行中
                },
                selectedStartedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowStartedUserOrg: false,
                selectedProcessUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowProcessUserOrg: false,
                processTemplateList: [],
                processStateList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: 1,
                        label: '进行中'
                    }, {
                        value: 2,
                        label: '已完成'
                    }],
                taskState: [
                    // {
                    //     value: null,
                    //     label: '全部'
                    // },
                    {
                        value: 2,
                        label: '已完成'
                    },
                    {
                        value: 1,
                        label: '进行中'
                    },
                    {
                        value: 4,
                        label: '待认领'
                    }, {
                        value: 5,
                        label: '已延期'
                    }, {
                        value: 6,
                        label: '快到期'
                    }],
                processInstanceTypeList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: '0',
                        label: '不含子流程'
                    }, {
                        value: '1',
                        label: '含子流程'
                    }],
                isShowPreview: false,
                processList: [],
                processNameLoading: false
            };
        },
        props: {
            processState: {// 默认进行中
                type: [String, Number],
                default: 1 // 流程状态 ：默认 进行中
            },
            tableHeight: {
                type: Number,
                default: 450
            },
            tableStyle: {
                type: String,
                default: 'width: 100%;'
            },
            hideModeSwich: {
                type: Boolean,
                default: false
            },
            role: {
                type: String,
                default: ''
            },
            isFromBusTab: {
                type: Boolean,
                default: false
            },
            isListView: {// 我的流程列表模式：true 块模式 false
                type: Boolean,
                default: false
            },
            isSubProcessShow: {// 是否显示子流程列表
                type: Boolean,
                default: false
            },
            taskDefinitionKey: {
                type: String,
                default: ''
            }
        },
        async created () {
            // this._initPage();
            let currentUserStr = sessionStorage.getItem('currentUserInfo');
            if (currentUserStr) {
                let currentUserInfo = JSON.parse(currentUserStr);
                this.currentUserId = currentUserInfo.userId;
                this.currentUserName = currentUserInfo.trueName;
            }
            this.getApplications();
            // this._getFormData();
            await this.initProcessTemplateList().then(val => {
                this.changeLeftList();
            });
        },
        methods: {
            async _initPage () {
                this.isShowProcessDetail = false;
                this.isShowProcessDetailDrawer = false;
                this._getFormData();
            },
            async getApplications () {
                this.appsList = await getPublishedApplicationList();
            },
            clearSelectedAppId () {
                this.searchParams.processServiceId = '';
                this.currentTemplateList = this.processTemplateList;
                this.changeLeftList();
            },
            changeSelectedAppId () {
                // console.log(this.selectedAppId);
                this.searchParams.processServiceId = '';
                if (this.selectedAppId) {
                    // 根据APPId获取应用
                    for (let j = 0; j < this.appsList.length; j++) {
                        let app = this.appsList[j];
                        if (app.id === this.selectedAppId) {
                            this.selectedApp = app;
                        }
                    }
                    // 根据应用获取绑定的流程模板
                    if (this.selectedApp) {
                        if (!isEmpty(this.selectedApp.processServiceIds)) {
                            let processServiceIds = this.selectedApp.processServiceIds.split(',');
                            let processServiceNames = this.selectedApp.processServiceNames.split(',');
                            let selectedData = [];
                            for (let i = 0; i < processServiceIds.length; i++) {
                                selectedData.push({processServiceId: processServiceIds[i], templateName: processServiceNames[i]});
                            }
                            this.currentTemplateList = selectedData;

                            this.searchParams.processServiceId = this.currentTemplateList[0].processServiceId;
                            // 刷新流程列表信息
                            this.processServiceChange();
                        } else {
                            this.currentTemplateList = [];
                        }
                    } else {
                        this.currentTemplateList = this.processTemplateList;
                    }
                } else {
                    this.currentTemplateList = this.processTemplateList;
                }
            },
            async _getFormData () {
                this.getProcessListView();
            },
            async getProcessListView () {
                // console.log(111);
                this.loading = true;
                let params = {
                    pageSize: 1000,
                    currentPage: 1,
                    serviceName: this.searchKeyWord,
                    state: this.processState,
                    processStartedBy: this.processStartedBy
                };
                if (!isEmpty(this.role)) {
                    let tempProcessStartedBy = '';
                    // console.log(this.role);
                    if (this.role === 'startedBy') {
                        tempProcessStartedBy = '1';
                    } else if (this.role === 'participant') {
                        tempProcessStartedBy = '2';
                    } else if (this.role === 'assignee') {
                        tempProcessStartedBy = '3';
                        this.selectedProcessUser = {
                            selectedUserIds: this.currentUserId,
                            selectedUserNames: this.currentUserName
                        };
                        this.searchParams.assigneeUserId = this.selectedProcessUser.selectedUserIds;
                    };
                    params.processStartedBy = tempProcessStartedBy;
                    this.searchParams.processStartedBy = tempProcessStartedBy;
                    this.processStartedBy = tempProcessStartedBy;
                }
                if (this.taskInfo) {
                    params.relationProcessInstanceId = this.taskInfo.processInstanceId;
                    params.relationTaskInstanceId = this.taskInfo.id;
                }
                params.isSearchNowTasks = false;
                let formData = await getMenuProcessTreeList(Object.assign({}, {
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                }, this.searchParams));
                if (formData) {
                    this.instancesList = formData.data;
                    this.page.totalPageNum = formData.totalPageNum;
                    this.dealData();
                }
                // tempLoading.close();
                this.queryProcessList('');
                this.loading = false;
            },
            handleSearch (taskDefinitionKey) {
                if (!isEmpty(taskDefinitionKey)) {
                    if (taskDefinitionKey === '1') {
                        this.searchParams.taskDefinitionKey = '';
                    } else {
                        this.searchParams.taskDefinitionKey = taskDefinitionKey;
                    }
                }
                this.page.currentPage = 1;
                this._getFormData();
            },
            processServiceChange () {
                // 菜单模式需要更新菜单信息
                let param = {processServiceId: this.searchParams.processServiceId};
                this.$emit('initTaskMenu', param);
                this.page.currentPage = 1;
                this._getFormData();
            },
            queryTableData (currentPage) {
                this.page.currentPage = currentPage;
                this.dealData();
            },
            async  handleViewProcessDetail (row) {
                const tempLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.instancesInfo = await getProcessInstancesDetail(row.id);
                tempLoading.close();
                this.isCancel = false;
                this.loadTimer = new Date().getTime();
                this.isShowProcessDetailDrawer = true;
            },
            handleModeSwitch () {
                this.$emit('handleModeSwitch', 'block');
            },
            async reloadProcess (processInstanceId, isUpdName) {
                this.isShowProcessDetail = false;
                this._initPage();
            },
            async handleCancelProcessInstances (instances) {
                this.$confirm(`您确定要删除流程[ ${instances.name} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    // tempLoading = this.$loading({
                    //     lock: true,
                    //     text: 'Loading',
                    //     spinner: 'el-icon-loading',
                    //     background: 'rgba(0, 0, 0, 0.7)'
                    // });
                    // await cancelProcessInstance(instances.id);
                    // tempLoading.close();
                    // // this.reloadProcess();
                    // this._initPage();
                    let tempLoading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$confirm('删除流程时，是否同时级联删除当前流程关联对应的表单、文件及子流数据数据？请慎重选择', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '级联数据全部删除',
                        cancelButtonText: '只删除流程',
                        type: 'warning'
                    }).then(async () => {
                        await cancelProcessInstance(instances.id);
                        tempLoading.close();
                        this._initPage();
                    }).catch(async action => {
                        if (action === 'cancel') {
                            await deleteProcessInstance(instances.id);
                            tempLoading.close();
                            this._initPage();
                        } else {
                            tempLoading.close();
                        }
                    });
                }).catch(() => {
                });
            },
            async handelShowDiagram (instances) {
                // console.log(instances);
                this.instancesInfo = instances;
                await this.setProcessViewInfo(instances);
                this.loadTimer = new Date().getTime();
                this.isShowDiagram = true;
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.processDiagrams.setProcessState(this.isFinish);
                    this.$refs.processDiagrams.resetDiagramUrl();
                }, 0);
            },
            async handelProcessDetail (isReloadProcess) {
                await this.setProcessViewInfo(this.instancesInfo);
                this.isShowSetting = true;
                this.isReloadProcess = isReloadProcess;
            },
            async setProcessViewInfo (instances) {
                const tempLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let tasks = await getAllUserTask(instances.id, instances.processServiceId, null, instances.deploymentId);
                this.taskList = tasks;
                let treeList = [];
                if (instances.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: instances.archiveTemplateId});
                }
                this.archiveTemplateTreeList = treeList;
                tempLoading.close();
            },
            cancelProcessSetting () {
                if (this.isReloadProcess) {
                }
                this.isShowSetting = false;
            },
            closeProcessSetting () {
                if (!this.isCancel) {
                    if (this.isReloadProcess) {

                    }
                    this.isShowSetting = false;
                }
            },
            loadMore () {
                // this.$message.success('加载下一页');
                this.currentCnt = this.instancesList.length;
                // console.log(this.currentCnt);
                if (this.currentCnt < this.instancesListTempCnt) {
                    let item = clone(this.instancesListTemp[this.currentCnt]);
                    // console.log(item);
                    this.instancesList.push(item);
                }
            },
            handleSizeChange (val) {
                this.page.pageSize = val;
                this.dealData();
            },
            dealData () {
            // 分页操作，每次取当前页*每页显示的条数再加每页显示的条数
                let cpage = (this.page.currentPage - 1) * this.page.pageSize;
                let count = this.page.pageSize + cpage;
                if (this.instancesList && this.instancesList.length > 0) {
                    this.instancesListTemp = this.instancesList.slice(cpage, count);
                } else {
                    this.instancesListTemp = [];
                }
            },
            async handelShowProcessRelate (row) {
                this.loadTimer = new Date().getTime();
                this.currentProcessInstanceId = row.id;
                setTimeout(() => {
                    this.$refs.processRelateTree._initPage();
                }, 0);
                this.isShowProcessRelate = true;
            },
            async handelShowReportRelateTree (item) {
                this.loadTimer = new Date().getTime();
                // this.processReportList = item.reports;
                let instancesInfo = await getProcessInstancesDetail(item.id);
                this.processReportList = instancesInfo.reports;
                setTimeout(() => {
                    this.$refs.reportRelateTree._initPage();
                }, 0);
                this.isShowReportRelateTree = true;
            },
            chooseProcessAssigneeUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.processUserOrgPop._initPage();
                }, 0);
                this.isShowProcessUserOrg = true;
            },
            processAssigneeSelectTrigger (selected) { // 流程负责人
                this.selectedProcessUser = selected;
                this.searchParams.assigneeUserId = selected.selectedUserIds;
                this.handleSearch();
                this.loadTimer = new Date().getTime();
            },
            chooseProcessStartedUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.startedUserOrgPop._initPage();
                }, 0);
                this.isShowStartedUserOrg = true;
            },
            processStartedUserSelectTrigger (selected) { // 流程发起人
                this.selectedStartedUser = selected;
                this.searchParams.startedByUserId = selected.selectedUserIds;
                this.handleSearch();
                this.loadTimer = new Date().getTime();
            },
            async initProcessTemplateList () {
                let { data } = await getProcessTemplateList({ state: 1, currentPage: 0, pageSize: 500 });// 查出最新版本的流程方案
                this.processTemplateList = data;
                this.currentTemplateList = data;
            },
            async processRecordView (row) {
                this.loadTimer = new Date().getTime();
                this.instancesInfo = row;
                this.currentProcessInstanceId = this.instancesInfo.id;
                // console.log("当前流程实例ID"+this.currentProcessInstanceId);
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.processAdjList._initPage();
                }, 0);
                this.isShowPreview = true;
            },
            handleStartProcess () {
                this.$emit('handleTemplateSwitch', true);
            },
            chooseProcess () {
                this.isShowProcessListDialog = true;
            },
            selectTrigger (selected) { // 选择流程
                this.searchParams.serviceName = selected.label;
            },
            selectProcessNameTrigger (id) { // 选择流程
                let selected = {id: '', label: ''};
                if (id) {
                    selected = this.processList.find((item) => {
                        return item.id === id;
                    });
                }
                this.searchParams.serviceName = selected.name;
                this.handleSearch();
            },
            async handleClickOk () {
                this.isShowProcessListDialog = false;
                // 选完流程后自动查询
                this.handleSearch();
            },
            navToBusiniessTaskTab () {
                this.$emit('navToBusiniessTaskTab');
                this.isShowProcessDetailDrawer = false;
            },
            async queryProcessList (name) {
                this.processNameLoading = true;
                let processInstances = await getProcessInstancesList({
                    pageSize: 1000,
                    currentPage: 1,
                    serviceName: name,
                    state: this.processState
                });
                if (processInstances && processInstances.data) {
                    this.processList = processInstances.data;
                }
    
                this.processNameLoading = false;
            },

            async handleShowOrgTreeView (row) {
                const tempLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(async () => {
                    let instancesInfo = await getProcessInstancesDetail(row.id);

                    let searchParams = {
                        isAllData: false,
                        modelId: '',
                        name: '',
                        selectedFields: '',
                        searchCondition: [],
                        selectedApprovalStatus: ''
                    };
                    searchParams.modelId = instancesInfo.reports[0].modelId;
                    searchParams.formId = instancesInfo.reports[0].formId;
                    searchParams.isFilterDuplicateData = true;
                    searchParams.processInstanceId = row.id;
                    let formData = await getModelFormReportTree(Object.assign({}, {
                        currentPage: 1,
                        pageSize: 10
                    }, searchParams));
                    let treeData = [];
                    if (formData.data) {
                        let tableDatas = [];
                        formData.data.forEach(item => {
                            let jsonObj = JSON.parse(item);
                            tableDatas.push(jsonObj);
                        });
                        treeData = tableDatas;
                    }
                    if (treeData && treeData.length > 0) {
                        let formData = await getModelFormReportOrgTree(instancesInfo.reports[0].formId, treeData[0].id);
                        this.treeOrgData = {};
                        if (formData.data) {
                            let tableDatas = {};
                            formData.data.forEach(item => {
                                tableDatas = JSON.parse(item);
                            });
                            this.treeOrgData = tableDatas;
                        }
                        this.isShowOrgTreeDialog = true;
                    } else {
                        this.$message({ message: '暂时没有数据', type: 'warning', uration: 3000 });
                    }
                    tempLoading.close();
                }, 0);
            },
            navToMyTaskMyAssignee () {
                this.navMyTaskMyAssignee();// 我负责
            },
            async saveProcessCommonUseConfig (row) {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let tasks = await getAllUserTask(row.id, row.processServiceId, null, row.deploymentId);
                let taskConfigInfo = JSON.stringify(tasks);
                let param = {
                    processServiceId: row.processServiceId,
                    deploymentId: row.deploymentId,
                    processInstanceId: row.id,
                    processInstanceName: row.name,
                    processDefinitionId: row.processDefinitionId,
                    taskConfigInfo: taskConfigInfo
    
                };
                await saveProcessCommonUseConfig(param);
                this.handleSearch();
                loading.close();
            },
            async cancelProcessCommonUseConfigBOByProcesssId (row) {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await cancelProcessCommonUseConfigBOByProcesssId(row.id);
                this.handleSearch();
                loading.close();
            },
            async handleByMeModeChange () {
                let param = {
                    keyStr: 'complateTreeMode',
                    valueStr: this.searchParams.complateTreeMode ? 1 : 0
                };
                await saveProcessTreeListQry(param);
                this._initPage();
            },
            changeLeftList () {
                if (isEmpty(this.searchParams.processServiceId)) {
                    if (this.processTemplateList) {
                        this.searchParams.processServiceId = this.processTemplateList[0].processServiceId;
                    }
                }
                let param = {processServiceId: this.searchParams.processServiceId};
                this.$emit('setShowleftList', param);
            },
            changeListMode () {
                this.$emit('changeListMode');
            },
            // ==================================任务操作相关方法begin=========================================
            async handleTaskDetail (id) {
                this.isShowTaskDetail = false;
                let loading;
                try {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.taskInfo = await getProcessTaskDetail(id);
                    loading.close();
                    this.loadTimer = new Date().getTime();
                    this.isShowTaskDetail = true;
                } catch (error) {
                    loading.close();
                }
            },
            async handleTaskClaim (params) {
                let { taskId } = params;
                await processTaskClaim(taskId);
                this.handleSearch();
            },
            async handleTaskComplete (taskData) {
                let task = {
                    taskDefinitionKey: this.taskInfo.taskDefinitionKey,
                    processInstanceId: this.taskInfo.processInstanceId,
                    processServiceId: this.taskInfo.processServiceId,
                    deploymentId: this.taskInfo.processDefinitionDeploymentId,
                    taskId: this.taskInfo.id,
                    operateType: taskData.operateType,
                    btnConditions: taskData.btnConditions,
                    operateOpinion: taskData.operateOpinion,
                    forms: taskData.forms,
                    modelInstanceIds: taskData.modelInstanceIds,
                    isApproval: this.taskInfo.taskNode.isApproval,
                    canUnStartApproval: this.taskInfo.taskNode.canUnStartApproval,
                    isSubProcess: this.taskInfo.taskNode.isSubProcess,
                    needAllSubProcess: this.taskInfo.taskNode.needAllSubProcess,
                    mainModelInfo: taskData.mainModelInfo,
                    operateName: taskData.operateName,
                    mainDataModelInstanceIds: taskData.mainDataModelInstanceIds
                };
                let loading;
                try {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    if (this.taskInfo.formObj) {
                        await this.renderSerialNumber(this.taskInfo.formObj.structure, task.forms, taskData.operateType);
                    }
                    await processTaskComplete(task);
                    loading.close();
                    this.isShowTaskDetail = false;
                    await this.handleSearch();
                } catch (error) {
                    console.error('任务保存出错：' + error);
                    loading.close();
                }
            },
            async handleTaskRevoke () {
                this.$confirm(`您确定要回退任务吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let task = {
                        processInstanceId: this.taskInfo.processInstanceId,
                        processServiceId: this.taskInfo.processServiceId,
                        deploymentId: this.taskInfo.processDefinitionDeploymentId,
                        taskId: this.taskInfo.id
                    };
                    let loading;
                    try {
                        loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        await processTaskRevoke(task);
                        loading.close();
                        this.isShowTaskDetail = false;
                        // await this.initTask();
                    } catch (error) {
                        console.error('任务回退出错：' + error);
                        loading.close();
                    }
                }).catch(() => {});
            },
            async handleTaskDelete () {
                this.$confirm(`您确定要删除任务吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await processTaskDelete(this.taskInfo.processInstanceId, this.taskInfo.id);
                    loading.close();
                    this.isShowTaskDetail = false;
                    await this.handleSearch();
                }).catch(() => {});
            },
            async handleTaskHidden () {
                this.$confirm(`您确定要隐藏该任务吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await processTaskHidden({processInstanceId: this.taskInfo.processInstanceId, taskInstanceId: this.taskInfo.id});
                    loading.close();
                    this.isShowTaskDetail = false;
                    await this.handleSearch();
                }).catch(() => {});
            },
            setShowleftList (isShowLeft) {
                this.isShowLeft = isShowLeft;
            },
            async handleTaskTemporarySave (taskData) {
                let task = {
                    taskDefinitionKey: this.taskInfo.taskDefinitionKey,
                    processInstanceId: this.taskInfo.processInstanceId,
                    processServiceId: this.taskInfo.processServiceId,
                    deploymentId: this.taskInfo.processDefinitionDeploymentId,
                    taskId: this.taskInfo.id,
                    forms: taskData.forms,
                    btnConditions: taskData.btnConditions,
                    modelInstanceIds: taskData.modelInstanceIds,
                    operateOpinion: taskData.operateOpinion,
                    mainModelInfo: taskData.mainModelInfo
                };
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    await this.renderSerialNumber(this.taskInfo.formObj.structure, task.forms, '1');// 1:代表完成，暂存于完成生成流水号规则一致
                    await processTaskTemporarySave(task);
                    loading.close();
                    // await this.refreshTaskDetail(this.taskInfo.id);
                } catch (error) {
                    console.log(error);
                } finally {
                    loading.close();
                }
            },
            async transferTask (param) {
                this.$confirm(`您确定要转办任务吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    await transferAssignee(param);
                    await this.handleSearch();
                    this.isShowTaskDetail = false;
                }).catch(() => {});
            },
            async renderSerialNumber (forms, formData, operateType) {
                if (forms && formData && forms.length > 0 && formData.length > 0) {
                    for (var dIndex = 0; dIndex < formData.length; dIndex++) {
                        // if (formData[dIndex].values.id) {
                        //     continue;
                        // }
                        let fData = formData[dIndex];
                        for (var findex = 0; findex < forms.length; findex++) {
                            let formInfo = forms[findex];
                            // 流水号保存生成字段渲染
                            if (fData.formId === formInfo.id && formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                                for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                                    let field = formInfo.fieldsList[fieldIndex];
                                    // 假如是流水号字段并且流水号有值的情况下就不走流水号生成逻辑了
                                    if (field.type === 'serialNumber' && !isEmpty(fData.values[field.id])) {
                                        console.log(field.name + '---------' + field.type);
                                        console.log(fData.values[field.id]);
                                        continue;
                                    }
                                    if (field.type === 'subform' && fData.values[field.id] && fData.values[field.id].length > 0) {
                                        for (var dataIndex = 0; dataIndex < fData.values[field.id].length; dataIndex++) {
                                            var subData = fData.values[field.id][dataIndex];
                                            for (var subFieldIndex = 0; subFieldIndex < field.options.fieldList.length; subFieldIndex++) {
                                                let subField = field.options.fieldList[subFieldIndex];
                                                if (subField.type === 'serialNumber' && subField.options.ext3 === '2' && !formData[dIndex].values.id && subField.options.config.options.length > 0 && !subData[subField.id]) {
                                                    await this.setSerialNumber(subField.options.config.options[0].value, subField, subData);
                                                } else if (subField.type === 'serialNumber' && subField.options.ext3 === '4' && operateType === '2' && !subField.isRead && subField.options.config.options.length > 0 && !subData[subField.id]) {
                                                    await this.setSerialNumber(subField.options.config.options[0].value, subField, subData);
                                                } else if (field.type === 'serialNumber' && field.options.ext3 === '6') { // 根据字段值进行生成流水号
                                                    let ext2Obj = JSON.parse(subField.options.ext2);
                                                    let curFieldValue = fData.values[ext2Obj.seriaNumberGenerateFieldId];
                                                    if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                                        await this.setSerialNumber(subField.options.config.options[0].value, subField, subData);
                                                    }
                                                }
                                            }
                                        }
                                        // field.type === 'serialNumber' 审批流字段
                                        // field.options.ext3,'2'：保存后生成，4：审批后生成
                                        // operateType，1:完成（即保存），2：同意/通过（即审批通过）
                                        // field.isRead,true（disabled）：不可编辑，其他（false/null），可编辑
                                        // fData.values[field.formField],判断此字段是否已存在
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '2' && !formData[dIndex].values.id && field.options.config.options.length > 0 && !fData.values[field.formField]) {
                                        await this.setSerialNumber(field.options.config.options[0].value, field, fData.values);
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '4' && operateType === '2' && !field.isRead && field.options.config.options.length > 0 && !fData.values[field.formField]) {
                                        await this.setSerialNumber(field.options.config.options[0].value, field, fData.values);
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '6') { // 根据字段值进行生成流水号
                                        let ext2Obj = JSON.parse(field.options.ext2);
                                        let curFieldValue = fData.values[ext2Obj.seriaNumberGenerateFieldId];
                                        if (ext2Obj.seriaNumberGenerateFieldIdValue && typeof (ext2Obj.seriaNumberGenerateFieldIdValue) === 'object') {
                                            for (let i = 0; i < ext2Obj.seriaNumberGenerateFieldIdValue.length; i++) {
                                                if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue[i]) {
                                                    await this.setSerialNumber(field.options.config.options[0].value, field, fData.values);
                                                }
                                            }
                                        } else {
                                            if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                                await this.setSerialNumber(field.options.config.options[0].value, field, fData.values);
                                            }
                                        }
                                    } else if (field.type === 'serialNumber') { // 多规则的流水号生成规则
                                        let ext2 = field.options.ext2;
                                        if (ext2) {
                                            let ext2Obj = JSON.parse(ext2);
                                            if (ext2Obj.moreSerialNumber) { // 多规则配置
                                                let serialNumberRuleList = ext2Obj.serialNumberRuleList;
                                                for (let i = 0; i < serialNumberRuleList.length; i++) {
                                                    let element = serialNumberRuleList[i];
                                                    let takeEffectField = element.takeEffectField;
                                                    let takeEffectFieldValue = element.takeEffectFieldValue;
                                                    let formFieldVal = formData.values[takeEffectField];
                                                    if (takeEffectFieldValue.indexOf(formFieldVal) !== -1) { // 满足条件了
                                                        if (element.seriaNumberDepartTypeFormFieldId) {
                                                            ext2Obj.seriaNumberDepartTypeFormFieldId = element.seriaNumberDepartTypeFormFieldId;
                                                        }
                                                        if (element.seriaNumberDepartTypeFormFieldIdValue) {
                                                            ext2Obj.seriaNumberDepartTypeFormFieldIdValue = element.seriaNumberDepartTypeFormFieldIdValue;
                                                        }
                                                        if (element.seriaNumberSelectTypeFormFieldId) {
                                                            ext2Obj.seriaNumberSelectTypeFormFieldId = element.seriaNumberSelectTypeFormFieldId;
                                                        }
                                                        field.options.ext2 = JSON.stringify(ext2Obj);
                                                        await this.setSerialNumber(element.selectedNode.id, field, fData.values, formInfo);
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            async setSerialNumber (sid, field, formData) {
                if (sid) {
                    let numberObj = await getSerialNumber(sid);
                    if (numberObj) {
                        formData[field.formField] = numberObj.newSerialNumber;
                        formData[field.formField + '-sn'] = numberObj.sn;
                    }
                }
            }
            // ==================================任务操作相关方法end=========================================
        }
    };
</script>

<style lang="less">
    .processListView-list {
        height: 100%;
        width: 100%;
        margin-top: -14px;
        .tools-bar {
            position:fixed;
            width:100%;
            height:auto;
            overflow-y:auto;
            min-height: 40px;
            justify-content: flex-start;
        }
        .table-main {
            // height:540px;
            overflow-y:auto;
        }
        a{ 
            font-size:15px;
            text-decoration:none; //去掉默认下滑线
            color: #3F51B5; //设置默认颜色
        }
        a:hover{
            text-decoration:none;//鼠标放上面不显示下划线
            color:#409eff; //设置鼠标放上去颜色
        } 
        .cancelBtn{
            background-color: #f56c6c;
            border-color: #f56c6c;
        }
    }
    .business-report-tree{
        .process-report-dialog{
            .el-dialog__body{
                height: ~'calc(100% - 10vh)';
                margin-top: -2vh;
                padding: 20px 20px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ProcessTemplateMenuMode/ProcessListView.vue